<template>
	<div>
		<title>鸿利智能</title>
		<div class="i-background">
			<div>
				<img src="/static/img/help@2x1022.png"/>
				<div>
					<p>此设备类型：{{help.name}}</p>
					<p>设备SN编号：{{help.sn}}</p>
					<div style="height:18px;"></div>
					<mt-field type="tel" placeholder="手机号" v-model="form.custom_phone"></mt-field>
					<div style="height:8px;"></div>
					<mt-field placeholder="问题反馈" type="textarea" rows="3" v-model="form.custom_service_content"></mt-field>
					<div style="height:20px;"></div>
					<mt-button @click.native="prior" type="default" style="width: 100%;color:#fff;background:#e9a727;">提交</mt-button>
					<div style="height:16px;padding-top: 6px;">
						<a href="#/download" style="float: left;text-decoration:underline;color:#e9a727;">APP下载</a>
						<a :href="'#/issue/'+help.name" style="float: right;text-decoration:underline;color:#e9a727;">使用说明</a>
					</div>
					<div style="text-align: center;position:absolute;bottom: 24px;left:0;width: 100vw;color:#e9a727">
						官方网站：<a href="http://www.hooply.com" style="color:#e9a727;text-decoration:underline;">www.hooply.com</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { Field,Button,Toast } from 'mint-ui';
	export default {
		computed: {
			
		},
		data() {
			return {
				help:{},
				form:{}
			}
		},
		methods: {
			prior() {
				this.$store.dispatch('post',{u:'/custom_service_record/app_add',d:this.form}).then(function(res){
			    	if(res.err==0){
			    		Toast({
							message: '提交成功，请耐心等待！',
							iconClass: 'iconfont icon-gou'
						});
						return
			    	}
			    	Toast({
						message: res.data,
					});
				})
			},
		},
		mounted() {
			let self=this
			self.form.dev_fn=self.$route.params.fn
			self.$store.dispatch('post',{u:'/dev/get',d:{fn:self.$route.params.fn}}).then(function(res){
		    	if(res.err==0){
		    		self.help=res.data
					return
		    	}
		    	Toast({
					message: res.data,
				});
			})
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/issue.vue